import { render, staticRenderFns } from "./newAcgDetail.vue?vue&type=template&id=3415ef76&scoped=true&"
import script from "./newAcgDetail.vue?vue&type=script&lang=js&"
export * from "./newAcgDetail.vue?vue&type=script&lang=js&"
import style0 from "./newAcgDetail.vue?vue&type=style&index=0&id=3415ef76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3415ef76",
  null
  
)

export default component.exports